import { Col, Form, Row } from "react-bootstrap";

const CompanyFields = ({ form, handleChange, regimes }) => (
  <Row className="g-2">
    <Col xs={12}>
      <h6 className="text-primary fw-bold mb-0">Datos fiscales</h6>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>Tipo de persona</Form.Label>
        <Form.Select name="type" value={form.type} onChange={handleChange}>
          <option value="fisica">Persona Física</option>
          <option value="moral">Persona Moral</option>
        </Form.Select>
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          RFC<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="taxIdentification"
          value={form.taxIdentification}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>

    <Col md={6}>
      <Form.Group>
        <Form.Label>
          {form.type === "moral" ? "Razón social" : "Nombre"}
          <span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="name"
          value={form.name}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    {form.type === "moral" && (
      <Col md={6}>
        <Form.Group>
          <Form.Label>Nombre comercial</Form.Label>
          <Form.Control
            name="businessName"
            value={form.businessName}
            onChange={handleChange}
          />
        </Form.Group>
      </Col>
    )}

    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Tipo de régimen fiscal<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Select
          name="taxRegime"
          value={form.taxRegime}
          onChange={handleChange}
          required
        >
          <option value="">Seleccione...</option>
          {regimes.map((r) => (
            <option key={r.code} value={r.code}>
              {r.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

    <Col xs={12}>
      <h6 className="text-primary fw-bold mb-0 mt-2">Domicilio fiscal</h6>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Calle<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="street"
          value={form.street}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Exterior<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="exteriorNumber"
          value={form.exteriorNumber}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>Interior</Form.Label>
        <Form.Control
          name="interiorNumber"
          value={form.interiorNumber}
          onChange={handleChange}
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Colonia<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="suburb"
          value={form.suburb}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Municipio / alcaldía<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="municipality"
          value={form.municipality}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Estado<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="state"
          value={form.state}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>
          Código postal<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Form.Control
          name="postalCode"
          value={form.postalCode}
          onChange={handleChange}
          required
        />
      </Form.Group>
    </Col>

    <Col xs={12}>
      <h6 className="text-primary fw-bold mb-0 mt-2">Teléfono y correo</h6>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>Teléfono</Form.Label>
        <Form.Control
          name="phone"
          value={form.phone}
          onChange={handleChange}
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group>
        <Form.Label>Correo electrónico</Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
      </Form.Group>
    </Col>
  </Row>
);

export default CompanyFields;
